import { useOnboardingStep, usePayApplicationFee } from '@onboarding/hooks'
import {
  OnboardingActions,
  OnboardingStatuses,
  paths,
  useMerchantQry,
  useOnboardingActionQry
} from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useHistory } from 'react-router-dom'

import OnboardingBannerInner from './OnboardingBannerInner'

type OnboardingBannerProps = {
  collapsed?: boolean
}

const OnboardingBanner = ({ collapsed }: OnboardingBannerProps) => {
  const history = useHistory()

  const { merchant } = useMerchantQry()
  const { onboardingAction } = useOnboardingActionQry()
  const { payApplicationFee } = usePayApplicationFee()
  const { currentOnboardingStep, totalSteps } = useOnboardingStep()

  const handleContinue = () => {
    switch (onboardingAction) {
      case OnboardingActions.NOT_STARTED:
        history.push(paths.onboarding.selectType())
        break

      case OnboardingActions.ONBOARDING:
        history.push(paths.onboarding.continueOnboarding())
        break

      case OnboardingActions.DOCUMENTS:
        history.push(paths.onboarding.documents())
        break

      case OnboardingActions.QUESTIONNAIRE:
        history.push(paths.onboarding.questionnaireKyb())
        break
    }
  }

  switch (onboardingAction) {
    case OnboardingActions.NOT_STARTED:
    case OnboardingActions.ONBOARDING:
    case OnboardingActions.DOCUMENTS:
    case OnboardingActions.QUESTIONNAIRE:
      if (merchant?.onboardingStatus === OnboardingStatuses.APPROVED_EXPIRING_DOCUMENT) {
        return (
          <OnboardingBannerInner
            caption={tr('FRONTEND.ONBOARDING.EXPIRING_DOCUMENT.MESSAGE', 'Expiring document')}
            title={tr(
              'FRONTEND.ONBOARDING.EXPIRING_DOCUMENT.TITLE',
              'Your document is expiring, upload newer one to avoid limitation of services'
            )}
            onClick={handleContinue}
            tooltipCollapsed={collapsed}
          />
        )
      }
      return (
        <OnboardingBannerInner
          caption={`${tr(
            'ONBOARDING.STATUS.TITLE.NOT_STARTED',
            'Verify your account'
          )} ${currentOnboardingStep}/${totalSteps}`}
          onClick={handleContinue}
          tooltipCollapsed={collapsed}
        />
      )

    case OnboardingActions.APPLICATION_FEE:
      return (
        <OnboardingBannerInner
          caption={`${tr('FRONTEND.ONBOARDING.APPLICATION_FEE.MESSAGE', 'Complete your account')} ${currentOnboardingStep}/${totalSteps}`}
          title={tr(
            'FRONTEND.ONBOARDING.APPLICATION_FEE.TITLE',
            'You need to pay your application fee to enable your primary account.'
          )}
          onClick={payApplicationFee}
          tooltipCollapsed={collapsed}
        />
      )

    case OnboardingActions.UNDER_REVIEW:
      return (
        <OnboardingBannerInner
          waiting={true}
          caption={`${tr(
            'ONBOARDING.STATUS.TITLE.NOT_STARTED',
            'Verify your account'
          )} ${currentOnboardingStep}/${totalSteps}`}
          subtext={tr('FRONTEND.ONBOARDING.UNDER_REVIEW', 'Under review.')}
          tooltipCollapsed={collapsed}
        />
      )
  }

  return null
}

export default OnboardingBanner
